import {
  action, actionOn, computed, thunk,
} from 'easy-peasy';
import { PartnerStoreModel } from './types';
import { WorkflowStatus } from '../../api/partner/partnerApiTypes';
import { getPartnerInfo } from '../../api/partner/partner';
import handleError from '../../api/apiErrorHandle';

const partnerStore : PartnerStoreModel = {
  partnerInfo: undefined,
  status: 'idle',

  isPartnerDeactivated: computed(
    state => state.partnerInfo?.workflowStatus === WorkflowStatus.DEACTIVATED,
  ),

  fetchPartnerInfo: thunk(async (actions, _, { getState, getStoreState }) => {
    if (getState().status !== 'idle') {
      return;
    }

    const { partnerCode } = getStoreState().user.currentUser;
    const isPartnerChanged = (): boolean => (
      getStoreState().user.currentUser.partnerCode !== partnerCode
    );

    actions.setStatus('loading');

    try {
      const partnerInfo = await getPartnerInfo();

      if (isPartnerChanged()) {
        return;
      }

      actions.setPartnerInfo(partnerInfo);
      actions.setStatus('ready');
    } catch (error) {
      if (isPartnerChanged()) {
        return;
      }

      actions.setStatus('error');

      handleError(error);
    }
  }),

  setPartnerInfo: action((state, payload) => {
    state.partnerInfo = payload;
  }),
  setStatus: action((state, payload) => {
    state.status = payload;
  }),

  resetOnUserChange: actionOn(
    (_, storeActions) => [storeActions.user.changePartner, storeActions.user.logout],
    (state) => {
      state.partnerInfo = undefined;
      state.status = 'idle';
    },
  ),
};

export default partnerStore;
